import { useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import Small from 'UIComponents/elements/Small';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { ACADEMY_VIDEO } from '../enums/ModalTypes';
// @ts-expect-error Not converted yet
import { openModal } from '../actions/Actions';

// help videos live at https://app.hubspot.com/files/53/?folderId=88910028828 provided by Kara Susvilla
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ACADEMY_VIDEO_KEYS = {
  WHAT_IS_HUBSPOT_VIDEO: 'WHAT_IS_HUBSPOT_VIDEO',
  ADDING_VIDEOS_TO_CONTENT: 'ADDING_VIDEOS_TO_CONTENT',
  PRIORITIZING_ACCESSIBILITY: 'PRIORITIZING_ACCESSIBILITY',
  GENERATING_LEADS: 'GENERATING_LEADS',
  ANALYZING_PERFORMANCE: 'ANALYZING_PERFORMANCE'
};
export const ACADEMY_VIDEO_IDS = {
  WHAT_IS_HUBSPOT_VIDEO: 88909718279,
  ADDING_VIDEOS_TO_CONTENT: 88890675536,
  PRIORITIZING_ACCESSIBILITY: 88907104900,
  GENERATING_LEADS: 88905526709,
  ANALYZING_PERFORMANCE: 89558945458
};
const AcademyVideoLink = ({
  className,
  videoKey,
  use = 'link'
}) => {
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(openModal(ACADEMY_VIDEO, {
      videoKey
    }));
  };
  const buttonEl = /*#__PURE__*/_jsxs(UIButton, {
    use: "link",
    className: className,
    size: "small",
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "playerPlay",
      size: 12,
      className: use === 'link' ? 'm-right-1' : ''
    }), /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "FileManagerCore.academyVideos.watch",
      options: {
        videoTitle: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `FileManagerCore.academyVideos.${videoKey.toLowerCase()}.title`
        })
      }
    })]
  });
  return use === 'dropdown' ? buttonEl : /*#__PURE__*/_jsx(Small, {
    children: buttonEl
  });
};
export default AcademyVideoLink;